const UserRoles = Object.freeze({
    ADMIN: "Administrador",
    VOTANTE: "Votante",
    COOPERADO: "Cooperado",
    GESTOR:"Gestor"
  });
  
export default UserRoles;